import { render, staticRenderFns } from "./EditBibleDialog.vue?vue&type=template&id=5a9f7135&scoped=true&"
import script from "./EditBibleDialog.vue?vue&type=script&lang=js&"
export * from "./EditBibleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9f7135",
  null
  
)

export default component.exports